/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=151d8064"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/prod-xqb-front-h5/xqb-front-h5/24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__